import { HeaderGroup } from "@tanstack/react-table";
import { VirtualItem } from "@tanstack/react-virtual";

type SkeletonRowProps<T> = {
  rowsLength: number;
  headerGroup: HeaderGroup<T>;
  lastVirtualRow: VirtualItem;
};

const SkeletonRows = <T,>({ rowsLength = 1, headerGroup, lastVirtualRow }: SkeletonRowProps<T>) => {
  if (!lastVirtualRow) return null;

  return Array.from({ length: rowsLength }).map((_, index) => (
    <tr
      className="group absolute flex w-full animate-pulse"
      data-testid={"table-loading-row"}
      key={index}
      style={{
        height: `${lastVirtualRow.size}px`,
        transform: `translateY(${lastVirtualRow.start + lastVirtualRow.size * (index + (lastVirtualRow.start === 0 ? 0 : 1))}px)`,
      }}
    >
      {headerGroup.headers.map((header, index) => (
        <td
          key={index}
          style={{
            minWidth: "300px",
          }}
          className="h-9 w-full flex-1 border-b border-r border-gray-200 bg-gray-100"
        />
      ))}
    </tr>
  ));
};

export default SkeletonRows;
